import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const RejectPaymentModal = ({ show, onClose, onConfirm, loading }) => {
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");

  const isOther = reason === "Other";
  const isSubmitDisabled = !reason || (isOther && remarks.trim() === "");

  useEffect(() => {
    if (!show) {
      setReason("");
      setRemarks("");
    }
  }, [show]);

  const handleSubmit = () => {
    if (isSubmitDisabled) return;

    onConfirm({
      reason,
      remarks,
    });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">Reject Payment</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="small text-muted mb-3">
          Please select a reason. This will be recorded and shared with the
          institution.
        </p>

        {/* Reason */}
        <Form.Group className="mb-3">
          <Form.Label className="fw-semibold">
            Rejection Reason <span className="text-danger">*</span>
          </Form.Label>

          <Form.Select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Select reason</option>
            <option value="Invalid proof">Invalid proof</option>
            <option value="Amount mismatch">Amount mismatch</option>
            <option value="Reference ID not found">
              Reference ID not found
            </option>
            <option value="Duplicate payment">Duplicate payment</option>
            <option value="Other">Other</option>
          </Form.Select>
        </Form.Group>

        {/* Remarks */}
        <Form.Group>
          <Form.Label className="fw-semibold">
            Additional Comments{" "}
            {isOther && <span className="text-danger">*</span>}
          </Form.Label>

          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Add remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Form.Group>

        <Alert variant="warning" className="small mt-3 mb-0">
          ⚠ Once rejected, this payment cannot be approved again.
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="danger"
          disabled={isSubmitDisabled || loading}
          onClick={handleSubmit}
        >
          {loading ? "Rejecting..." : "Confirm Reject"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectPaymentModal;
